module.exports = __webpack_public_path__ + "img/icons-sjfx-student.bf0d2847.png";